function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.0317 7.38248C29.599 8.20545 29.9478 9.19057 29.9946 10.2542C31.7452 10.8704 33 12.5387 33 14.5C33 16.9853 30.9853 19 28.5 19H6C4.35376 19 2.86238 18.337 1.77828 17.2635L11.3238 9.70659C11.6744 9.89384 12.0748 10 12.5 10C12.8814 10 13.2429 9.91458 13.5663 9.76182L18.1166 13.7433C18.0409 13.982 18 14.2362 18 14.5C18 15.8807 19.1193 17 20.5 17C21.8807 17 23 15.8807 23 14.5C23 14.1776 22.939 13.8694 22.8278 13.5864L29.0317 7.38248ZM27.6175 5.96826L21.4136 12.1722C21.1306 12.061 20.8224 12 20.5 12C20.1186 12 19.7571 12.0854 19.4337 12.2382L14.8834 8.25673C14.9591 8.01802 15 7.76378 15 7.5C15 6.11929 13.8807 5 12.5 5C11.1193 5 10 6.11929 10 7.5C10 7.72071 10.0286 7.93474 10.0823 8.13858L0.609477 15.6379C0.219151 14.8418 0 13.9465 0 13C0 9.68629 2.68629 7 6 7C6.02064 7 6.04126 7.0001 6.06185 7.00031C6.55381 3.05385 9.92027 0 14 0C17.6456 0 20.7216 2.43849 21.686 5.77338C22.5093 5.2822 23.4717 5 24.5 5C25.6575 5 26.7315 5.35756 27.6175 5.96826Z",
  fill: "#2196F3"
});

var SvgLogoSmall = function SvgLogoSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 33,
    height: 19,
    viewBox: "0 0 33 19",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-small.066037e6.svg";
export { ForwardRef as ReactComponent };